import { createRoot } from 'react-dom/client'
// Axios
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
// Apps

import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'

import "react-datepicker/dist/react-datepicker.css";

import { isChrome } from 'react-device-detect';


/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/style.react.scss'
import { AppRoutes } from './app/routing/AppRoutes'
import { AuthProvider } from './app/modules/auth'
import { ThemeModeProvider } from './_metronic/partials/layout/theme-mode/ThemeModeProvider'

import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './redux/ROOT';
import { Provider } from 'react-redux'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './styles/education-ui.scss';
import * as Sentry from "@sentry/react";
import {useEffect} from "react";

declare global {
  interface Window {
    lintrk?: (event: string, data: object) => void;
  }
}

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */

Sentry.init({
  dsn: "https://d95147c2dd0114e9f876dd6db5b5f73d@o4509231024832512.ingest.de.sentry.io/4509231027519568",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
  isChrome && require('./_metronic/assets/sass/style-chrome.scss')

  createRoot(container).render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <MetronicI18nProvider>
            <ThemeModeProvider>
              <AuthProvider>
                <AppRoutes />
                <ToastContainer position='top-right' autoClose={6000} limit={3} newestOnTop
                  closeOnClick={false} pauseOnFocusLoss pauseOnHover draggable={false} />
              </AuthProvider>
            </ThemeModeProvider>
          </MetronicI18nProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  )
}
